// extracted by mini-css-extract-plugin
export default {"container":"Ir-z","heading":"Jr-z","text":"Kr-z","info":"Lr-z","link":"Mr-z","fullMaxWidth":"Nr-z"};